import React, { useState, useRef } from 'react';
import Image from 'material-ui-image';
import AttachFileIcon from '@material-ui/icons/AttachFile';
import { Hidden, Grid, TextField, Button, Box, Paper, Divider } from '@material-ui/core';
import { useHistory } from 'react-router-dom';
import { makeStyles } from '@material-ui/styles';
import { useSelector } from 'react-redux';
import { useSnackbar } from 'material-ui-snackbar-provider';
import { useTranslation } from 'react-i18next';
import { useAddImageMutation } from '../../apis/backend';


const useStyles = makeStyles(theme => ({
  formActions: {
    '& .MuiButton-root': {
      marginRight: theme.spacing(1),
    }
  },
  previewImage: {
  }
}));


const ImageForm = () => {
  const imageInputRef = useRef(null);
  const [uploadImage, setUploadImage] = useState('');
  const [imageUrl, setImageUrl] = useState('#');
  const [imageName, setImageName] = useState();
  const history = useHistory();
  const chainId = useSelector(state => state.doris.selectedChain);
  const siteId = useSelector(state => state.doris.selectedSite);
  const snackbar = useSnackbar();
  const { t } = useTranslation();
  const classes = useStyles();

  const [ addImage ] = useAddImageMutation();

  const handleImageChange = event => {
    let image = event.target.files[0];
    if (image) {
      setImageUrl(URL.createObjectURL(event.target.files[0]));
      setImageName(event.target.files[0].name);
      setUploadImage(event.target.files[0]);
    } else {
      setUploadImage('');
      setImageName('');
      setImageUrl('#');
    }
  };

  const handleImageNameChange = event => {
    setImageName(event.target.value);
  };

  const uploadFile = async () => {
    try {
      if (!uploadImage) {
        console.log('Error: missing image to upload.');
        return;
      }

      const formData = new FormData();
      formData.append('upload', uploadImage);
      formData.append('imageName', imageName);
      await addImage({ payload: formData, type: 'print', chainId, siteId }).unwrap();
      snackbar.showMessage(t('image-create-success'));
      history.push('/imagebank');
    } catch (error) {
      snackbar.showMessage(t('image-create-fail', { message: error.data.error }));
      console.log(error);
    }
  };

  return (
    <>
      <Box m={2}>
        <Grid container spacing={1}>
          <Grid item xs={12} lg={4}>
            <Box height="100%" width="100%" display="flex" px={2}>
              <Box mr={4} width="100%">
                <Box mt={2} mb={2}>
                  <input
                    id="upload"
                    onChange={handleImageChange}
                    ref={imageInputRef}
                    label="test"
                    accept="image/*"
                    name="upload"
                    style={{display: 'none'}}
                    required={true}
                    type="file" />
                  <label htmlFor="upload">
                    <Button
                      variant="outlined"
                      fullWidth
                      color="primary"component="span"
                      startIcon={<AttachFileIcon />}>
                        Choose File
                    </Button>
                  </label>
                </Box>
                <TextField
                  fullWidth
                  name="imageName"
                  onChange={handleImageNameChange}
                  required={false}
                  value={imageName}
                  helperText="Upload the file with a given name."
                  InputLabelProps={{
                    shrink: imageName,
                  }}
                  label="File Name (optional)" />
                <Box mt={5} className={classes.formActions}>
                  <Grid container spacing={1}>
                    <Grid item sm={6}>
                      <Button
                        variant="contained"
                        color="primary"
                        fullWidth
                        onClick={uploadFile}>
                          Upload
                      </Button>
                    </Grid>
                    <Grid item sm={6}>
                      <Button
                        variant="outlined"
                        color="primary"
                        fullWidth
                        onClick={() => history.goBack()}>
                          Cancel
                      </Button>
                    </Grid>
                  </Grid>
                </Box>
              </Box>
              <Hidden mdDown>
                <Divider flexItem orientation="vertical"/>
              </Hidden>
            </Box>
          </Grid>
          <Grid item xs={12} lg={8}>
            <Box m={0}>
              <Paper variant="outlined">
                <Box height="auto" className={classes.previewImage} p={1}>
                  <Image
                    src={imageUrl}
                    animationDuration={0}
                    style={{
                      paddingTop: 0,
                      minHeight: '300px',
                      overflow: 'visible',
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center'
                    }}
                    imageStyle={{
                      height: 'auto',
                      maxHeight: '600px',
                      width: 'auto',
                      maxWidth: '100%',
                      position: 'relative'
                    }} />
                </Box>
              </Paper>
            </Box>
          </Grid>
        </Grid>
      </Box>
    </>
  );
};


export default ImageForm;
